<div class="wrapper">
  <div class="block-center mt-4 wd-xl">
    <div class="card card-flat">
      <div class="card-header text-center topnavbar">
        <a href="#">
          <img
            class="block-center rounded"
            src="assets/img/logo.png"
            alt="Image"
            style="padding-bottom: 5px"
          />
        </a>
      </div>
      <div class="card-body">
        <p class="text-center py-2">
          {{ isChangePassword ? 'PLEASE CHANGE YOUR PASSWORD' : 'SIGN IN TO CONTINUE' }}
        </p>
        <form
          [formGroup]="valForm"
          class="form-validate mb-3"
          role="form"
          name="loginForm"
          novalidate=""
          (submit)="onSubmit()"
        >
          <div class="form-group">
            <div class="input-group with-focus">
              <input
                class="form-control border-right-0"
                id="exampleInputUsername1"
                type="text"
                name="username"
                placeholder="Enter username"
                autocomplete="off"
                formControlName="username"
                required=""
              />
              <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                  <em class="fa fa-envelope"></em>
                </span>
              </div>
            </div>

            <div
              class="text-danger"
              *ngIf="
                valForm.controls['username'].hasError('required') &&
                (valForm.controls['username'].dirty || valForm.controls['username'].touched)
              "
            >
              This field is required
            </div>
            <div
              class="text-danger"
              *ngIf="
                valForm.controls['username'].hasError('username') &&
                (valForm.controls['username'].dirty || valForm.controls['username'].touched)
              "
            >
              This field must be a valid username address
            </div>
          </div>
          <div class="form-group">
            <div class="input-group with-focus">
              <input
                class="form-control border-right-0"
                id="exampleInputPassword1"
                type="password"
                name="password"
                placeholder="Password"
                formControlName="password"
                required=""
              />
              <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                  <em class="fa fa-lock"></em>
                </span>
              </div>
            </div>
            <app-validation-errors [FormControl]="getControl('password')"></app-validation-errors>
          </div>
          <div *ngIf="isChangePassword">
            <div class="form-group">
              <div class="input-group with-focus">
                <input
                  class="form-control border-right-0"
                  id="newPassword"
                  type="password"
                  name="newPassword"
                  placeholder="New Password"
                  formControlName="newPassword"
                />
                <div class="input-group-append">
                  <span class="input-group-text text-muted bg-transparent border-left-0">
                    <em class="fa fa-lock"></em>
                  </span>
                </div>
              </div>
              <app-validation-errors
                [FormControl]="getControl('newPassword')"
              ></app-validation-errors>
            </div>
            <div class="form-group">
              <div class="input-group with-focus">
                <input
                  class="form-control border-right-0"
                  id="confirmNewPassword"
                  type="password"
                  name="confirmNewPassword"
                  placeholder="Confirm New Password"
                  formControlName="confirmNewPassword"
                />
                <div class="input-group-append">
                  <span class="input-group-text text-muted bg-transparent border-left-0">
                    <em class="fa fa-lock"></em>
                  </span>
                </div>
              </div>
              <app-validation-errors [FormControl]="getControl('confirmNewPassword')">
              </app-validation-errors>
            </div>
            <p class="text-warning">{{ passwordRules }}</p>
          </div>
          <button
            class="btn btn-block btn btn-outline-primary mt-3"
            type="submit"
            [disabled]="loading"
          >
            <dx-load-indicator class="button-indicator login-loader" [visible]="loading">
            </dx-load-indicator>
            Login
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
